module.exports = __webpack_public_path__ + "img/eyeclose.a86dec6a.svg";